import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import logo from "./assets/netflix.png"; // ✅ gunakan import langsung agar bundler tahu path-nya

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!username || !password) {
      setError("❌ Please enter username and password.");
      return;
    }

    try {
      setLoading(true);
      const res = await fetch("https://api.backofficemain.com/login_user.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      setLoading(false);

      if (data.success) {
        localStorage.setItem("user", JSON.stringify(data.user));
        if (onLogin) onLogin(data.user);
        navigate("/");
      } else {
        setError(data.message || "Invalid username or password.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("⚠️ Connection error. Please try again later.");
      setLoading(false);
    }
  };

  return (
    <div
      className="login-container d-flex justify-content-center align-items-center vh-100"
      style={{
        background: "linear-gradient(180deg, #ff0000, #ff5722)",
      }}
    >
      <div
        className="login-box shadow p-4 rounded-4 bg-white"
        style={{ width: "400px" }}
      >
        <div className="text-center mb-4">
          <img
            src={logo}
            alt="NetflixVIP Logo"
            width="80"
            style={{ borderRadius: "8px" }}
          />
          <h4 className="fw-bold text-danger mt-2">NetflixVIP</h4>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-semibold">Username</label>
            <input
              type="text"
              className="form-control"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Password</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <div className="alert alert-danger py-2">{error}</div>}

          <button
            type="submit"
            className="btn btn-danger w-100 fw-bold"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <div className="text-center mt-3">
          <p className="text-muted">
            Not a member?{" "}
            <span
              className="text-danger fw-semibold"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/register")}
            >
              Register Now
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}
